import style from '../../styles/components/form/ForgotPasswordForm.module.scss'

const ForgotPasswordForm = () => {
    return <form className={style.ForgotPasswordForm}></form>
}

export default ForgotPasswordForm
